module.exports = __webpack_public_path__ + "img/3.fd1b2553.png";